import React from 'react';
import { Icon } from 'ui';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import VersionHistoryInfo from './VersionHistoryInfo';

const LessonVersionList = ({ versions, lastLiRef }) => {
  const currentVersion = versions?.length > 0 ? versions[0].id : null;
  return (
    <ul>
      <li className="PublishedVersionCollection-columnHeader jc-sb d-f ff-ss fw-b fz-16">
        <span className="ml-32">{t('versions.version_info')}</span>
        <span className="mr-32">{t('versions.completed')}</span>
      </li>
      {versions?.map((v, versionIndex) => (
        <li
          ref={versionIndex === versions.length - 1 ? lastLiRef : null}
          key={v.id}
          className="PublishedVersionCollection-dataRow h-bc-gray-lightest py-16 d-f jc-sb pl-32 pr-58"
        >
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={v.preview_url}
            className="mr-32"
          >
            <VersionHistoryInfo
              version={v}
              currentVersion={currentVersion}
              textVariant={TEXT_VARIANTS.BODY_LINK}
            />
            <Icon name="external-link" className="c-link fz-16" />
          </a>
          <Text className="pr-40" variant={TEXT_VARIANTS.BODY}>
            {v.learner_count}
          </Text>
        </li>
      ))}
    </ul>
  );
};

export default LessonVersionList;
